
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Blog from "../pages/blog/page";
import SeoAudit from "../pages/services/seo-audit/page";
import TechnicalOptimization from "../pages/services/technical-optimization/page";
import ContentMarketing from "../pages/services/content-marketing/page";
import Linkbuilding from "../pages/services/linkbuilding/page";
import YandexSeo from "../pages/services/yandex-seo/page";
import GoogleSeo from "../pages/services/google-seo/page";
import YandexMaps from "../pages/services/yandex-maps/page";
import GoogleMaps from "../pages/services/google-maps/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/services/seo-audit",
    element: <SeoAudit />,
  },
  {
    path: "/services/technical-optimization",
    element: <TechnicalOptimization />,
  },
  {
    path: "/services/content-marketing",
    element: <ContentMarketing />,
  },
  {
    path: "/services/linkbuilding",
    element: <Linkbuilding />,
  },
  {
    path: "/services/yandex-seo",
    element: <YandexSeo />,
  },
  {
    path: "/services/google-seo",
    element: <GoogleSeo />,
  },
  {
    path: "/services/yandex-maps",
    element: <YandexMaps />,
  },
  {
    path: "/services/google-maps",
    element: <GoogleMaps />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
